module.exports = __webpack_public_path__ + "static/media/21ECLAC46.9fe89339.jpg";